import { calculateVerificationsAnalytics } from 'src/middlewares/utils';
import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import * as Schema from 'src/types/graphql';

import { useGetConfirmedRoles } from '../CareerHistory/data';

import { processVerified, processVerifiable, processNudge } from './utils';

export const useVerifications = () => {
  const { zone, language, locale } = useAppConfig();
  const languageLocale = `${language}-${locale}`;

  const { data, loading, error } = useQuery(Schema.GetVerificationsDocument, {
    variables: {
      zone,
      locale: languageLocale,
    },
  });
  const verifications = data?.viewer?.profileVerifications;

  const { verified, verifiedCredentialCount, expiryCount } = processVerified(
    verifications?.verified,
  );
  const { verifiable, verifiableCredentialCount } = processVerifiable(
    verifications?.verifiable,
  );

  const nudge = processNudge(verifications?.nudge);

  // Hide feature if feature is not useful for candidate, i.e. both sections will be empty
  const showVerifications =
    (verified && verified.length > 0) || (verifiable && verifiable.length > 0);

  // Calculate tracking props:
  const { confirmedRoles } = useGetConfirmedRoles();

  const verificationsTrackingProps = {
    ...calculateVerificationsAnalytics(verified, verifiable),
    profileCareerHistoryCount: confirmedRoles.length,
  };

  return {
    verified,
    verifiable,
    nudge,
    verifiedCredentialCount,
    verifiableCredentialCount,
    expiryCount,
    showVerifications,
    verificationsTrackingProps,
    loading,
    error,
  };
};
